import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import {useProyecto} from "../../../../Profile.jsx";
import {useEditor} from "../../../../../../App.jsx";
import {
    IconPresupuesto,
    IconProject,
    IconUsers
} from "../../../../../Customiz3r/components/ToolSelectorTop/Icons.jsx";
// import ItemPresupuestoEditor from './ItemPresupuestoEditor'; // Asegúrate de que este componente exista

const PresupuestoEditor = () => {
    const {proyecto, setProyecto} = useProyecto();
    const [presupuesto, setPresupuesto] = useState({
        proyecto: '',
        descripcion: '',
        estado: 'pendiente',
    });
    const [items, setItems] = useState([]); // Para almacenar la lista de ítems

    const {stateEditor, setStateEditor} = useEditor();

    useEffect(() => {
        if (stateEditor.editorID && stateEditor.editorID !== 'add') {
            // Cargar los datos del presupuesto
            axios.get(`/presupuestos/${stateEditor.editorID}/`)
                .then(response => {
                    setPresupuesto(response.data);
                    setItems(response.data.items); // Cargar los ítems del presupuesto
                })
                .catch(error => {
                    console.error('Error al cargar el presupuesto:', error);
                });
        }
    }, [stateEditor.editorID]);

    const handleChange = e => {
        const { name, value } = e.target;
        setPresupuesto(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        try {
            presupuesto.proyecto = proyecto.id;
            if (stateEditor.editorID === 'add') {
                // Crear nuevo presupuesto
                axios.post('/presupuestos/', presupuesto)
                    .then(response => {
                        if (response.status === 201) {
                            console.log("dataaaa", response.data)
                            setStateEditor({
                                ...stateEditor,
                                editor: true,
                                editorID: proyecto.id,
                                editorType: "proyecto_viewer"
                            });
                        }
                    })
                    .catch(error => {
                        console.error('Error al crear el presupuesto:', error);
                    });
            } else {
                // Editar presupuesto existente
                axios.put(`/presupuestos/${stateEditor.editorID}/`, presupuesto)
                    .then(response => {
                        if (response.status === 200) {
                            if (confirm('Presupuesto modificado, ¿quiere volver al presupuesto?')) {
                                setStateEditor({
                                    ...stateEditor,
                                    editor: true,
                                    editorID: presupuesto.id,
                                    editorType: "presupuesto_viewer"
                                });
                            }else{
                                /*setStateEditor({
                                    ...stateEditor,
                                    editor: true,
                                    editorID: presupuesto.id,
                                    editorType: "proyecto_viewer"
                                });*/
                            }

                        }
                    })
                    .catch(error => {
                        console.error('Error al modificar el presupuesto:', error);
                    });
            }
        } catch (error) {
            console.error('Error al guardar el presupuesto:', error);
        }
    };

    const handleDelete = async () => {
        try {
            if (confirm('¿Quieres borrar este presupuesto?')) {
                axios.delete(`/presupuestos/${stateEditor.editorID}`)
                    .then(() => {

                            setStateEditor({
                                ...stateEditor,
                                editorType: "proyecto_viewer",
                                editorIO: proyecto.id,
                                editor: true,
                            });

                    })
                    .catch(error => {
                        console.error('Error al borrar el presupuesto:', error);
                    });
            }
        } catch (error) {
            console.error('Error al borrar el presupuesto:', error);
        }
    };

    const handleAddItem = () => {
    };

    const handleEditItem = (itemId) => {
    };


    const handleAtrasProyecto = () => {
        setStateEditor({
            ...stateEditor,
            editor: true,
            editorType: "proyecto_view",
            editorID: proyecto.id

        });
    }
    const handleAtrasPresupuesto = () => {
        setStateEditor({
            ...stateEditor,
            editor: true,
            editorType: "presupuesto_viewer",
            editorID: presupuesto.id
        });
    }
    return (
        <div className="h-full mx-auto p-6">
            <div className="absolute top-3 right-2 flex space-x-3">
                <button
                    className="bg-blue-500 hover:bg-blue-600 text-white font-bold px-2 py-1 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-transform transform hover:scale-105 shadow-md hover:shadow-lg duration-200 ease-in-out"
                    onClick={handleAtrasPresupuesto}
                    aria-label="Presupuesto"
                >
                    <div className="flex items-center">
                        <IconPresupuesto className="w-6 h-6"/>
                        <span className="ml-2">Presupuesto</span>
                    </div>
                </button>
                <button
                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition duration-200 ease-in-out"
                    onClick={handleAtrasProyecto}
                    aria-label="Go back"
                >
                    <div className="flex items-center">
                        <IconProject className="w-6 h-6"/>
                        <span className="ml-2">Proyecto</span>
                    </div>
                </button>

            </div>
            <h2 className="text-3xl mb-4">{stateEditor.editorID === 'add' ? 'Añadir Presupuesto' : 'Editar Presupuesto'}</h2>

            <div className="mb-4">
                <label className="text-gray-700 dark:text-gray-300 text-lg font-bold mb-2">Descripción</label>
                <textarea
                    name="descripcion"
                    value={presupuesto.descripcion}
                    onChange={handleChange}
                    className="appearance-none block w-full bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white dark:focus:bg-gray-800"
                    placeholder="Descripción del presupuesto"
                />
            </div>

            <div className="mb-4">
                <label className="text-gray-700 dark:text-gray-300 text-lg font-bold mb-2">Estado</label>
                <select
                    name="estado"
                    value={presupuesto.estado}
                    onChange={handleChange}
                    className="appearance-none block w-full bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white dark:focus:bg-gray-800"
                >
                    <option value="pendiente">Pendiente</option>
                    <option value="en_revision">En Revisión</option>
                    <option value="aprobado">Aprobado</option>
                    <option value="rechazado">Rechazado</option>
                    <option value="enviado">Enviado al Cliente</option>
                </select>
            </div>

            {/*{stateEditor.editorID && stateEditor.editorID !== 'add' && (

                <div className="mb-4">
                    <h2 className="text-lg font-bold mb-2">Ítems del Presupuesto</h2>
                    <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700">
                        <thead>
                        <tr className="bg-gray-100 dark:bg-gray-700">
                            <th className="py-3 px-4 border-b text-left dark:text-gray-300">#</th>
                            <th className="py-3 px-4 border-b text-left dark:text-gray-300">Producto</th>
                            <th className="py-3 px-4 border-b text-left dark:text-gray-300">Unidades</th>
                            <th className="py-3 px-4 border-b text-left dark:text-gray-300">Precio por Unidad</th>
                            <th className="py-3 px-4 border-b text-left dark:text-gray-300">Descuento</th>
                            <th className="py-3 px-4 border-b text-left dark:text-gray-300">Total</th>
                            <th className="py-3 px-4 border-b text-left dark:text-gray-300">Acciones</th>
                        </tr>
                        </thead>
                        <tbody>
                        {items.map((item, index) => (
                            <tr key={item.id} className="hover:bg-gray-50 dark:hover:bg-gray-600 transition duration-150 ease-in-out">
                                <td className="py-2 px-4 border-b dark:border-gray-700">{index + 1}</td>
                                <td className="py-2 px-4 border-b dark:border-gray-700 dark:text-gray-300">{item.keyring.nombre}</td>
                                <td className="py-2 px-4 border-b dark:border-gray-700 dark:text-gray-300">{item.unidades}</td>
                                <td className="py-2 px-4 border-b dark:border-gray-700 dark:text-gray-300">{item.precio_por_unidad}</td>
                                <td className="py-2 px-4 border-b dark:border-gray-700 dark:text-gray-300">{item.descuento_valor_fijo}</td>
                                <td className="py-2 px-4 border-b dark:border-gray-700 dark:text-gray-300">{item.precio_total}</td>
                                <td className="py-2 px-4 border-b dark:border-gray-700">
                                    <button
                                        className="bg-blue-500 text-white py-1 px-3 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 dark:bg-blue-600 dark:hover:bg-blue-700"
                                        onClick={() => handleEditItem(item.id)}
                                    >
                                        Editar
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>

            )}*/}

            <div className="flex items-center justify-end">
                {/*{stateEditor.editorID && stateEditor.editorID !== 'add' && (
                    <button
                        onClick={handleAddItem}
                        className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        type="button"
                    >
                        Añadir Ítem
                    </button>
                )}*/}
                <button
                    onClick={handleSubmit}
                    className="flex-shrink-0 bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    type="button"
                >
                    Confirmar
                </button>

                {stateEditor.editorID && stateEditor.editorID !== 'add' && (
                    <button
                        onClick={handleDelete}
                        className="bg-transparent hover:bg-gray-500 text-gray-700 dark:text-gray-300 font-semibold hover:text-white py-2 px-4 border border-gray-500 hover:border-transparent rounded"
                        type="button"
                    >
                        Borrar
                    </button>
                )}
            </div>

        </div>
    );
};

export default PresupuestoEditor;
